export default {
  list: (state) => {
    return state.list;
  },
  current_opportunity: (state) => {
    return state.current_opportunity;
  },
  funnel_values: (state) => {
    return state.funnel_values;
  },
  loading: (state) => {
    return state.loading;
  },
};
